/**
 * @module EmptyNotifications
 * @package @geenius/notifications-react-css
 * @description Renders the empty-state used when there are no notifications to
 * display in the React vanilla CSS variant.
 */

import { FadeIn } from '@geenius/motion/react-css'
import type { JSX } from 'react'
import { cx } from '../lib/cx'
import { useNotificationCopy } from '../lib/notificationCopy'

/**
 * Props for the React CSS empty-state component.
 */
export interface EmptyNotificationsProps {
  className?: string
}

/**
 * Renders the empty notification state.
 *
 * @param props Optional style override for the empty-state container.
 * @returns The empty-state markup.
 */
export function EmptyNotifications({
  className,
}: EmptyNotificationsProps): JSX.Element {
  const { t } = useNotificationCopy()

  return (
    <FadeIn className={cx('notifications__empty', className)}>
      <span className={cx('notifications__empty-icon')}>🔔</span>
      <div className={cx('notifications__empty-title')}>
        {t('notifications.empty.title')}
      </div>
      <div className={cx('notifications__empty-text')}>
        {t('notifications.empty.description')}
      </div>
    </FadeIn>
  )
}
